import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=56aaf4c3&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=56aaf4c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aaf4c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56aaf4c3')) {
      api.createRecord('56aaf4c3', component.options)
    } else {
      api.reload('56aaf4c3', component.options)
    }
    module.hot.accept("./pay.vue?vue&type=template&id=56aaf4c3&scoped=true&", function () {
      api.rerender('56aaf4c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/specialty/pay.vue"
export default component.exports